// Validation utilities

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/** 6-digit registration OTP */
export const validateRegistrationOtp = (code) => {
  const s = String(code ?? "").trim();
  return /^\d{6}$/.test(s);
};

export const validatePassword = (password) => {
  const minLength = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasCapital = /[A-Z]/.test(password);
  
  return {
    isValid: minLength && hasNumber && hasCapital,
    errors: {
      minLength: !minLength ? "Password must be at least 8 characters" : null,
      hasNumber: !hasNumber ? "Password must contain at least 1 number" : null,
      hasCapital: !hasCapital ? "Password must contain at least 1 capital letter" : null
    }
  };
};

export const validatePhone = (phone) => {
  const phoneRegex = /^98\d{8}$/;
  return phoneRegex.test(phone);
};

export const validateUsername = (username) => {
  if (!username) {
    return { isValid: false, error: 'Username is required' };
  }
  
  if (username.length < 3) {
    return { isValid: false, error: 'Username must be at least 3 characters' };
  }
  
  if (username.length > 30) {
    return { isValid: false, error: 'Username must be less than 30 characters' };
  }
  
  const usernameRegex = /^[a-z0-9_]+$/;
  if (!usernameRegex.test(username)) {
    return { isValid: false, error: 'Username can only contain lowercase letters, numbers, and underscores' };
  }
  
  return { isValid: true, error: null };
};

export const validateFile = (file, allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf']) => {
  if (!file) return { isValid: false, error: "File is required" };
  
  if (!allowedTypes.includes(file.type)) {
    return { 
      isValid: false, 
      error: "File must be PNG, JPG, or PDF" 
    };
  }
  
  const maxSize = 5 * 1024 * 1024; // 5MB
  if (file.size > maxSize) {
    return { 
      isValid: false, 
      error: "File size must be less than 5MB" 
    };
  }
  
  return { isValid: true, error: null };
};

